// src/components/Login.js
import React, { useState } from 'react';
import styled from 'styled-components';
import { authApiClient } from '../../api/apiClient';
import { CornerCard, Field, Input, PrimaryButton, ErrorText } from '../../components/ui';
import { color, font } from '../../theme/tokens';

// 内容卡片（V18 结界枠）
const FormWrapper = styled(CornerCard)`
    width: 100%;
    max-width: 440px;
    margin: 0 auto;
`;

const Title = styled.h2`
    margin: 0 0 28px;
    padding-bottom: 16px;
    border-bottom: 1px solid ${color.line};
    font-family: ${font.display};
    font-weight: 800;
    font-size: 24px;
    letter-spacing: 0.24em;
    text-align: center;
    color: ${color.text};
`;

const FormBody = styled.form`
    display: flex;
    flex-direction: column;
    gap: 18px;
`;

// 这里的 onLogin 是从 Admin.js 传过来的，需要接收并调用
const Login = ({ onLogin }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(''); // 开始尝试时清空错误
        try {
            const response = await authApiClient.post('login-admin', { username, password });
            // --- 修改点 4: 调用从 Admin.js 传来的 onLogin 函数 ---
            onLogin(response.data.user);
        } catch (err) {
            setError(err.response?.data?.message || '用户名或密码错误。');
            console.error(err);
        }
    };

    return (
        // --- 修改点 3: 移除了 <Container> 包裹 ---
        <FormWrapper>
            <Title>管理员登录</Title>
            <FormBody onSubmit={handleSubmit}>
                <Field>
                    <label htmlFor="admin-username">用户名</label>
                    <Input
                        id="admin-username"
                        type="text"
                        placeholder="用户名"
                        autoComplete="username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                </Field>
                <Field>
                    <label htmlFor="admin-password">密码</label>
                    <Input
                        id="admin-password"
                        type="password"
                        placeholder="密码"
                        autoComplete="current-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        $invalid={!!error}
                        aria-describedby="admin-login-error"
                    />
                </Field>
                <ErrorText id="admin-login-error" role="alert">{error}</ErrorText>
                <PrimaryButton type="submit" $block>登录</PrimaryButton>
            </FormBody>
        </FormWrapper>
    );
};

export default Login;
